module.exports = __webpack_public_path__ + "static/media/img188.18ff830e.jpg";